import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import Box from "~components/shared/todo-lib-react-components/box"
import GuestUserFormInputs from "~components/shared/guest-user-form-inputs"

export default function WidgetPersonalInfoForm() {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <GuestUserFormInputs />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: { marginY: "30px" },
    })
}
